import { render, staticRenderFns } from "./product-star-display.vue?vue&type=template&id=42dea02d&scoped=true"
import script from "./product-star-display.vue?vue&type=script&lang=js"
export * from "./product-star-display.vue?vue&type=script&lang=js"
import style0 from "./product-star-display.vue?vue&type=style&index=0&id=42dea02d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dea02d",
  null
  
)

export default component.exports